import { CompanyUserPermission } from '~apis/role/type';
import checkIsOnboardingUser from '~hooks/checkIsOnboardingUser';
import { useGetFinanceInfo } from '~hooks/queries/dashboard/query';
import { useUserPermissions } from '~hooks/queries/role/query';
import { useGetSettings } from '~hooks/queries/setting/query';
import useTradesQuery from '~hooks/queries/useTradesQuery';
import { useTradeAllowed } from '~hooks/tax-invoice/useTradeAllowed';
import { useCompanyId } from '~hooks/useCompanyId';

import { FINANCE_GROUP_ITEMS } from './constant';

export const useFinanceMenu = () => {
  const { companyId } = useCompanyId();
  const { data: userPermissionsData } = useUserPermissions();
  const userPermissions = userPermissionsData?.Data?.data?.companyUserPermissions ?? [];
  const { data: financeInfoData, isLoading: isFinanceInfoLoading } = useGetFinanceInfo({
    companyId,
    checkPermission: true,
    permissionEnabled: userPermissions.includes(CompanyUserPermission.CAN_MANAGE_CLOBE_FINANCE),
  });

  const settings = useGetSettings();
  const { data: tradeData, isLoading: isTradeLoading } = useTradesQuery(1, 1000, companyId);

  const settingData = settings?.data?.Data?.data;
  const step = settingData?.onboardingStep;
  const isOnboardingUser = checkIsOnboardingUser(step);
  const financeInfo = financeInfoData?.Data?.data?.items || [];
  const trades = tradeData?.Data?.data?.items || [];

  const hasApprovedTerm = financeInfo.some(
    (item) => item?.type === 'TERM_OFFERED' && item?.finalOffer === 'OFFERED',
  );
  const hasAnyTrade = trades.length > 0;
  const isTradeAllowed = useTradeAllowed(companyId);

  const isLoading = isFinanceInfoLoading || isTradeLoading;

  const menuItems = FINANCE_GROUP_ITEMS.filter((item) => {
    if (isOnboardingUser) {
      return item.link === '/clobe/loans';
    }

    switch (item.activeKey) {
      case 'finance-trade-revenue':
        return hasApprovedTerm && isTradeAllowed;
      case 'finance-trade':
        return hasAnyTrade;
      default:
        return true;
    }
  });

  return {
    menuItems,
    isLoading,
  };
};
